<!--
 * @Description  : 
 * @Author       : lcs
 * @Date         : 2023-12-22 00:52:43
 * @LastEditors  : luchaoshun@ihaier.com
 * @LastEditTime : 2023-12-26 23:40:19
-->
<template>
  <div class="chatLoading" v-animationStart>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  directives: {
    animationStart: {
      inserted: (el) => {
        setTimeout(() => {
          el.classList.add('flip-up')
        }, 500)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.chatLoading {
  padding: 16px 10px;
  display: grid;
  grid-template-columns: repeat(5, 15px);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  margin: 0 0 16px 0;
  opacity: 0;
  width: -moz-fit-content;
  width: fit-content;
  margin-left:65px;
}

.chatLoading div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1890ff;
  animation: wq_load 1s ease infinite;
}

.chatLoading div:nth-child(1) {
  animation-delay: 0.2s;
}

.chatLoading div:nth-child(2) {
  animation-delay: 0.4s;
}

.chatLoading div:nth-child(3) {
  animation-delay: 0.6s;
}

.chatLoading div:nth-child(4) {
  animation-delay: 0.8s;
}

.chatLoading div:nth-child(5) {
  animation-delay: 1s;
}

@keyframes wq_load {
  0% {
    opacity: 1;
    transform: scale(1.3);
  }

  100% {
    opacity: 0.2;
    transform: scale(0.3);
  }
}
</style>
